import { RouterProvider } from 'react-router-dom'
import { router } from '@/router'
import { AuthProvider } from '@/contexts/AuthContext'

/**
 * Root application component.
 * Only responsibility: mount the router and providers.
 * All layout, auth, and feature logic lives in dedicated layers.
 */
export default function App() {
  return (
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  )
}
